import { SearchResultsStyle } from "@omni/ui/components/Search/SearchResults/searchResults.style";
import { cn } from "@omni/utils/styles";
import { useInView } from "react-intersection-observer";

import { ResultListHitComponentProps } from "@/components/Search/SearchResults/components/results/components/resultList/resultList.container";
import { ContentPageAlgoliaModel } from "@/types/service/algolia/contentPage.algolia.model";

type ContentHitComponentProps =
    ResultListHitComponentProps<ContentPageAlgoliaModel>;

const ContentHitComponent = ({ hit }: ContentHitComponentProps) => {
    const trackContentTile = (inView: boolean) => {
        if (inView) {
            //TODO: gaan we dit volgen
        }
    };

    const { ref: invViewRef } = useInView({
        triggerOnce: true,
        onChange: trackContentTile
    });

    return (
        <article
            className={SearchResultsStyle.resultList.contentResultListHit()}
            ref={invViewRef}
        >
            <a
                href={hit.externalPath}
                rel={"bookmark"}
                className={cn(
                    "tw:no-underline tw:text-black tw:hover:no-underline tw:block tw:h-full"
                )}
            >
                {hit.image && (
                    <img
                        className={cn(
                            "tw:w-full tw:h-30 tw:object-cover tw:block"
                        )}
                        src={hit.image}
                        alt={hit.title}
                        data-sizes={"auto"}
                        data-src={hit.image}
                    />
                )}
                <h5 className={"text-primary clamp-2"}>{hit.title}</h5>
                <p className="clamp-4">{hit.description}</p>
            </a>
        </article>
    );
};

export { ContentHitComponent };
